import React, {Component} from 'react'

const Jeyu = {
  ContactBox: {
    background:'rgb(1, 72, 82)',
    padding: '183px 10px 140px'
  },
  bannerPhotoBox: {
    width: 200,
    height: 200,
    overflow: 'hidden',
    borderRadius: 150,
    boxShadow: '1px 1px 7px rgba(0,0,0,.2)'
  },
  bannerPhoto: {
    width: 200,
    height: 200,
  },
  center: {
   display: 'block',
   textAlign: 'left'
  },
  h1: {
    fontSize: 30,
    textAlign: 'left',
    fontWeight: 'unset',
    color: '#fff',
    margin: '10px 0 0 0'
  },
  p: {
    fontSize: 20,
    color: '#fff',
    textAlign: 'left',
    margin: 0,
    fontWeight: 100
  },
  pinfo: {
    fontSize: 18,
    textAlign: 'left',
    margin: '20px 0',
    fontWeight: 100
  },
  h2: {
    fontSize: 23,
    fontWeight: 300
  },
  tag: {
    background: 'rgb(21, 222, 203)',
    color: 'rgb(1, 72, 82)',
    padding: '2px 15px',
    borderRadius: 7,
    fontSize: 16,
    marginRight: 10,
    fontWeight: 500
  },
  time: {
    marginLeft: 10
  },
  haspt: {
    paddingTop: 17
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  labelFirst: {
    background: '#fff',
    border: '1px solid #dcdcdd',
    borderRadius: 7,
    color: '#333',
    fontSize: 15,
    padding: '7px 15px 10px',
    margin: '10px 10px 10px 0',
    cursor: 'pointer',
    display: 'inline-block'
  },
  label: {
    background: '#fff',
    border: '1px solid #dcdcdd',
    borderRadius: 7,
    color: '#333',
    fontSize: 15,
    padding: '7px 15px 10px',
    margin: '10px',
    cursor: 'pointer',
    display: 'inline-block'
  },
  none: {
    display: 'none'
  },
  block: {
    display: 'block'
  },
  hasMargin: {
    margin: '0 10px'
  },
  inputText: {
    height: 40,
    width: 300,
    border: '1px solid #014852',
    margin: '10px 0',
    borderRadius: 3,
    padding: '3px 7px'
  },
  fluid: {
    width: '100%',
    padding: '20px 10px 50px'
  },
  textarea: {
    width: '100%',
    minHeight: 250,
    padding: 10
  },
  btn: {
    background: '#014852',
    color: '#fff',
    padding: '7px 17px',
    borderRadius: 3,
    border: '1px solid #014852',
    fontSize: 15,
    cursor: 'pointer',
    margin: '15px 0 0 0'
  }
}

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Consumption_patterns: true
    }
    this.handleRadioChange = this.handleRadioChange.bind(this)
    this.onLoadHandler = this.onLoadHandler.bind(this)
  }
  handleRadioChange(event) {
    const target = event.target;
    const value = target.type === 'radio' ? target.radio : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    })
  }
  onLoadHandler() {
    window.location = ('/Thanks');
  }
  componentDidMount () {
    window.scrollTo(0, 0)
  }
  componentWillUnmount() {
    window.scrollTo(0, 0)
  }
  render() {
    return(
     <div className="container">
      <iframe name="hidden_iframe" id="hidden_iframe" style={Jeyu.none} ></iframe>
      <form id="gform" method="POST" style={Jeyu.fluid} target="hidden_iframe" onSubmit={this.onLoadHandler}
        action="https://script.google.com/macros/s/AKfycbxeY6adXf25fkUQnLHnjk7PoVQoAegNZ9xwfZOU1e20S9ei5ok/exec">
       <div>
        <p>請選擇身分</p>
        <input type="radio" id="AnUser" name="Consumption_patterns" className="labelbtn"
         checked={this.state.Consumption_patterns}
         onChange={this.handleRadioChange}
         style={Jeyu.none}
         value="消費者"
        />
        <label htmlFor="AnUser" style={Jeyu.labelFirst} >消費者</label>
        <input type="radio" id="DiskBusiness" name="Consumption_patterns" className="labelbtn"
         checked={this.state.Consumption_patterns}
         onChange={this.handleRadioChange}
         style={Jeyu.none}
         value="盤商"
        />
        <label htmlFor="DiskBusiness" style={Jeyu.label}>盤商</label>
        <input type="radio" id="Dealer" name="Consumption_patterns" className="labelbtn"
        checked={this.state.Consumption_patterns}
        onChange={this.handleRadioChange}
        style={Jeyu.none}
        value="經銷商"
        />
        <label htmlFor="Dealer" style={Jeyu.label}>經銷商</label>
       </div>
       <div>
        <p>您的聯絡資料</p>
        <div style={Jeyu.flexRow} className="flexRow">
         <div>
          <label style={Jeyu.block} htmlFor="name">姓名:</label>
          <input type="text" required="true" value={this.state.value} onChange={this.handleChange} id="name" style={Jeyu.inputText} className="inputText" name="Name" />
         </div>
         <div style={Jeyu.hasMargin}>
          <label style={Jeyu.block} htmlFor="email">信箱:</label>
          <input type="email" required="true" value={this.state.value} onChange={this.handleChange} id="email" style={Jeyu.inputText} className="inputText" name="Email"/>
         </div>
        </div>

        <div style={Jeyu.flexRow} className="flexRow">
         <div>
          <label style={Jeyu.block} htmlFor="company">公司名稱:</label>
          <input type="text" required="true" value={this.state.value} onChange={this.handleChange} id="company" style={Jeyu.inputText} className="inputText"  name="Company"/>
         </div>
         <div style={Jeyu.hasMargin}>
          <label style={Jeyu.block} htmlFor="tel">連絡電話:</label>
          <input type="tel" required="true" value={this.state.value} onChange={this.handleChange} id="tel" style={Jeyu.inputText} className="inputText"  name="Tel"/>
         </div>
        </div>

       </div>
       <div>
        <p>請輸入您的詢問</p>
        <textarea style={Jeyu.textarea} name="Question"></textarea>
       </div>
       <input type="submit" value="Submit" style={Jeyu.btn} />
      </form>
     </div>
    )
  }
}

export default class Contact extends Component {
  render() {
    return(
      <div className="container-fluid">
       <div className="row">
        <div style={Jeyu.ContactBox} className="ContactBox">
         <div className="container">
          <div className="row">
           <div className="xs-12 sm-12 md-12 lg-12">
            <div>
             <h1 style={Jeyu.h1}>聯絡我們</h1>
             <p style={Jeyu.p}>如果有任何疑問或建議，歡迎洽詢</p>
            </div>
           </div>
          </div>
         </div>
        </div>
        <ContactForm />
      </div>
     </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Contact.js